import { combineReducers } from "redux"
import { UserReducer, UserState, UserAction } from "./UserReducer"

export const AuthReducer = combineReducers({
    user: UserReducer
})

export interface AuthState {
    user: UserState
}

export type AuthAction = UserAction
